export default theme => {
  return {
    root: {
      width: '100%',
      zIndex: 1,
      overflow: 'hidden'
    },
    appFrame: {
      position: 'relative',
      display: 'flex',
      width: '100%',
      height: '100%'
    },
    appBar: {
      position: 'absolute',
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    drawer: {
      width: 240
    },
    content: {
      width: '100%',
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      height: 'calc(100% - 76px)',
      marginTop: 76
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/FordCALincoln/theme/components/auto/index.js